export default {
  title: 'Terminal',
  stats: {
    terminal_battery_level: 'Batterijniveau',
    terminal_battery_state: 'Oplaadstatus',
    auto_accept_orders: 'Bestellingen automatisch accepteren',
  },
  auto_accept_orders_modal: {
    title: 'Weet u zeker dat u bestellingen automatisch wilt accepteren?',
    buttons: {
      activate: 'Activeren',
      cancel: 'Annuleren',
    },
  },
  feedback: {
    update_success: 'Succesvol bijgewerkt',
    update_failed: 'Informatie bijwerken mislukt. Probeer het opnieuw.',
  },
};
